module.exports = __webpack_public_path__ + "4e6067f02377fb1b463d7948cc53f2ab.svg";